import { createReducer } from '@reduxjs/toolkit';

import { openSettingsDialog, closeSettingsDialog, toggleSettingsDialog, setSettingsDialogOpen } from '../actions/settingsDialogActions';
import { initialSettingsDialogState } from '../initialState';

/**
 * Settings dialog reducer for the core domain
 */
const settingsDialogReducer = createReducer(initialSettingsDialogState, builder => {
  builder
    .addCase(openSettingsDialog, state => {
      state.isSettingsDialogOpen = true;
    })
    .addCase(closeSettingsDialog, state => {
      state.isSettingsDialogOpen = false;
    })
    .addCase(toggleSettingsDialog, state => {
      state.isSettingsDialogOpen = !state.isSettingsDialogOpen;
    })
    .addCase(setSettingsDialogOpen, (state, action) => {
      state.isSettingsDialogOpen = action.payload;
    });
});

export default settingsDialogReducer;
